export { SchoolModeApiEntryPoint } from './schoolModeApiEntry';
